import React, { Component } from 'react'
import { Grid, Col, Row } from 'react-flexbox-grid'
import RBButton from '../../controls/RBButton'
import { localize } from '../../util/Localizer'
import InputField from '../../controls/InputField'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { fetchProvinces } from '../../redux/actions/submitExpenseActions'
import RBSelectField from '../../controls/RBSelectField'
import { withStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

class AddClinicForm extends Component {
  constructor (props) {
    super(props)
    this.onAddClicked = this.onAddClicked.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.addClinic = this.addClinic.bind(this)
    this.isLoading = this.isLoading.bind(this)
    this.postalCode = React.createRef()
    this.phone = React.createRef()
    this.state = {
      clinicName: props.newClinic.clinicName || '',
      phone: props.newClinic.phone || '',
      address: props.newClinic.address || '',
      city: props.newClinic.city || '',
      postalCode: props.newClinic.postalCode || '',
      clinicId: props.newClinic.clinicId || '',
      province: props.newClinic.province || 'ON',
      country: 'Canada',
      newClinicError: {},
      isMakingApiCall: false
    }
  }

  componentDidMount () {
    if (this.props.provinces.length === 0) {
      this.props.fetchProvinces()
    }
  }

  onAddClicked () {
    const state = this.state
    if (this.validate()) {
      let clinic = {
        clinicName: state.clinicName,
        phone: state.phone,
        address: state.address,
        city: state.city,
        province: state.province,
        provValue: state.provValue,
        postalCode: state.postalCode,
        country: 'Canada'
      }
      let post = {
        ClinicInformationOtherExtendedHealthCare: {
          ClinicName: state.clinicName,
          AddressLine1: state.address,
          AddressLine2: '',
          City: state.city,
          PhoneNumber: state.phone,
          postalCode: state.postalCode,
          Province: state.province
        },
        RegistrationNumber: 'newClinic'
      }

      // set so we know we are making an API call
      this.setState({ isMakingApiCall: true })

      // need to call in a set timeout so the set state gets updated since redux calls propchanges and
      // we have a race condition cause isMakingApiCal is not set to true and re-loads the existing values
      window.setTimeout(() => {
        if (this.props.edit) {
          let ec = { ...post }
          delete ec.RegistrationNumber
          ec.clinicId = this.state.clinicId
          ec.ClinicInformationOtherExtendedHealthCare.clinicId = this.props.newClinic.clinicId
          // this updates an existing clinic
          this.props.editClinic(ec, () => {
            this.setState({ isMakingApiCall: false })
            this.addClinic(clinic, ec.clinicId)
          })
        } else {
          // this adds a new clinic
          this.props.postClinic(post, this.props.type, () => {
            this.setState({ isMakingApiCall: false })
            this.addClinic(clinic, this.props.clinicResponse.clinicId)
          })
        }
      }, 100)
    }
  }

  addClinic (clinic, clinicId) {
    let c = { ...clinic, clinicId }
    this.props.addClinic(c, 'clinic')
  }

  validate () {
    let isValid = true
    const newClinicError = this.state.newClinicError
    let p = (this.state.phone.replace(/\D/g, '')) || 0
    let pc = this.state.postalCode.replace(/_/g, '')

    if (!this.state.clinicName) {
      newClinicError.clinic = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noClinicError')
      isValid = false
    } else {
      newClinicError.clinic = ''
    }

    if (!this.state.phone) {
      newClinicError.phone = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noPhoneError')
      isValid = false
    } else {
      newClinicError.phone = ''
    }
    if (p.length !== 10) {
      newClinicError.phone = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noPhoneError')
      isValid = false
    } else {
      newClinicError.phone = null
    }

    if (!this.state.address) {
      newClinicError.address = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noAddressError')
      isValid = false
    } else {
      newClinicError.address = ''
    }

    if (!this.state.city) {
      newClinicError.city = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noCityError')
      isValid = false
    } else {
      newClinicError.city = ''
    }

    if (pc.length !== 7) {
      newClinicError.postalCode = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noPostalCodeError')
      isValid = false
    } else {
      newClinicError.postalCode = ''
    }

    this.setState({ newClinicError })
    return isValid
  }

  onCancel () {
    this.props.onCancel()
  }

  updateState (e, v) {
    if (e.target) {
      let stateItem = e.target.id
      this.setState({ [stateItem]: v })
    } else {
      this.setState({ ...e })
    }
  }

  isLoading () {
    return this.state.isMakingApiCall // this.props.clinicLoading || this.props.eclinicLoading
  }

  render () {
    const { classes = {} } = this.props
    let newClinicError = this.state.newClinicError
    const state = this.state
    let addButtonLabel = this.props.edit ? localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.editClinic') : localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.addClinic')
    let formTitle = this.props.edit ? localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.editClinic') : localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.title')
    let p = (state.phone.replace(/\D/g, '')) || 0
    let pc = state.postalCode.replace(/_/g, '')
    return (
      <Grid fluid className={this.props.classes.container}>
        <Row start='xs'>
          <Col xs={12}>
            <h3 className='marginBottom0px'>{formTitle}</h3>
            <p className='titledLabelTitle'>{localize('error.account.activateAccount.20001018')}</p>
          </Col>
        </Row>
        <br />
        <Row start='xs'>
          <Col xs={12}>
            <InputField
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.Clinic')}
              fullWidth
              id='clinicName'
              errorText={!state.clinicName && newClinicError.clinic ? newClinicError.clinic : null}
              value={this.state.clinicName}
              onChange={(e, v) => this.updateState(e, v)}
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <InputField
              type='tel'
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.Phonenumber')}
              mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              fullWidth
              id='phone'
              errorText={p.length !== 10 && newClinicError.phone ? newClinicError.phone : null}
              value={this.state.phone}
              onChange={(e, v) => this.updateState(e, v)}
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <InputField
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.Address')}
              fullWidth
              id='address'
              errorText={!state.address && newClinicError.address ? newClinicError.address : null}
              value={this.state.address}
              onChange={(e, v) => this.updateState(e, v)}
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={6}>
            <InputField
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.City')}
              fullWidth
              id='city'
              errorText={!state.city && newClinicError.city ? newClinicError.city : null}
              value={this.state.city}
              onChange={(e, v) => this.updateState(e, v)}
            />
          </Col>
          <Col xs={6}>
            <RBSelectField
              data={this.props.provinces}
              id='province'
              label={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.Province')}
              sendValues={(v) => this.setState(v)}
              selected={this.state.province}
              fullWidth
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={6}>
            <InputField
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.PostalCode')}
              fullWidth
              id='postalCode'
              mask={[/[A-Z]/i, /\d/, /[A-Z]/i, ' ', /\d/, /[A-Z]/i, /\d/]}
              errorText={pc.length !== 7 && newClinicError.postalCode ? newClinicError.postalCode : null}
              value={this.state.postalCode}
              onChange={(e, v) => this.updateState(e, v)}
            />
          </Col>
          <Col xs={6}>
            <RBSelectField
              data={[{ id: 'Canada', text: 'Canada' }]} // to change if we get more countries...
              id='country'
              label={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.Country')}
              sendValues={(v) => this.setState(v)}
              selected={this.state.country}
              fullWidth
            />
          </Col>
        </Row>
        <br /><br />
        <Row start='xs'>
          <Col xs={12} sm={6}>
            <RBButton fullWidth label={localize('common.cancel')} variant='outlined' onClick={() => this.onCancel()} className={classnames(classes.margin)} disabled={this.isLoading()} />
          </Col>
          <Col xs={12} sm={6}>
            <RBButton fullWidth label={addButtonLabel} variant='contained' primary onClick={() => this.onAddClicked()} className={classnames(classes.margin)} loading={this.isLoading()} />
          </Col>
        </Row>
      </Grid>
    )
  }
}

function mapStateToProps (state, ownProps) {
  const provinces = (state.SubmitExpenseReducer.provinces || []).map((prov) => {
    return { id: prov, text: prov }
  })

  return {
    clinicLoading: state.SubmitPractitionerReducer.clinicLoading,
    clinicResponse: state.SubmitPractitionerReducer.clinicResponse,
    clinicError: state.SubmitPractitionerReducer.clinicError,

    eclinicLoading: state.SubmitPractitionerReducer.eclinicLoading,
    eclinicResponse: state.SubmitPractitionerReducer.eclinicResponse,
    eclinicError: state.SubmitPractitionerReducer.eclinicError,

    provinces: provinces
  }
}
const ConnectedAddClinicForm = connect(mapStateToProps, { fetchProvinces })(injectIntl(AddClinicForm))

const Styles = {
  margin: {
    marginTop: 10
  },
  container: {
    minWidth: 400,
    maxWidth: 550
  }
}

export default withStyles(Styles)(ConnectedAddClinicForm)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/AddClinicForm.js